import { createContext, useContext, useEffect, useState } from 'react';
import { http } from './http';
import { clientStore } from './clientStore';
import { authStore } from './authStore';
import { setLogoCookie, clearLogoCookie } from './brandLogo';

const Ctx = createContext(null);

// H2.8 — la config del cliente viene SIEMPRE de la API por tenant
// (/api/g/v2/clients/me/config). Se acabaron los src/clients/<id>.json y el
// modo "local": un solo build sirve a todos los clientes.
export function ClientConfigProvider({ children }) {
  const [config, setConfig] = useState(clientStore.get());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (config || !authStore.getToken()) return;
    setLoading(true);
    http
      .get('/api/g/v2/clients/me/config')
      .then((r) => {
        clientStore.set(r.data);
        setConfig(r.data);
        // Recuerda el logo del cliente para personalizar el próximo login en
        // este dispositivo; si el proyecto no tiene logo, limpia la cookie
        // (el login volverá a mostrar el de Instrutrónica).
        if (r.data?.branding?.logoUrl) setLogoCookie(r.data.branding.logoUrl);
        else clearLogoCookie();
      })
      .catch(() => {
        // sin config no se bloquea la app; las páginas usan defaults
      })
      .finally(() => setLoading(false));
  }, [config]);

  const reload = () => {
    clientStore.clear();
    setConfig(null);
  };

  return (
    <Ctx.Provider value={{ config, loading, reload }}>{children}</Ctx.Provider>
  );
}

export function useClientConfig() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useClientConfig debe usarse dentro de ClientConfigProvider');
  return ctx;
}
